'use strict';

var _defineProperty2 = require('babel-runtime/core-js/object/define-property');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterSimpleSelectOptions = exports.filterMultiSelectOptions = undefined;

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _getUniqueLabel = require('../utility/getUniqueLabel');

var _getUniqueLabel2 = _interopRequireDefault(_getUniqueLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { (0, _defineProperty3.default)(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// We are implementing our own method of filtering options to overcome an issue with React Selectize
// failing to clear the search input after selection
var filterMultiSelectOptions = exports.filterMultiSelectOptions = function filterMultiSelectOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var search = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  // Create map of selected values to optimize comparison of options to values
  var selectedValuesMap = values.reduce(function (acc, _ref) {
    var value = _ref.value;
    return _extends({}, acc, _defineProperty({}, value, true));
  }, {});

  var lowercaseSearch = search.toLowerCase();

  return options.filter(function (_ref2) {
    var groupId = _ref2.groupId,
        label = _ref2.label,
        value = _ref2.value;

    if (selectedValuesMap[value]) {
      return false; // This value has been selected
    }

    if (!lowercaseSearch) {
      return true; // No search filter is applied
    }

    // Allow search by group using unique labels
    var uniqueLabel = (0, _getUniqueLabel2.default)({ groupId: groupId, label: label }).toLowerCase();

    return uniqueLabel.includes(lowercaseSearch);
  });
};

var filterSimpleSelectOptions = exports.filterSimpleSelectOptions = function filterSimpleSelectOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var lowercaseSearch = search.toLowerCase();

  return options.filter(function (_ref3) {
    var groupId = _ref3.groupId,
        label = _ref3.label;

    if (!lowercaseSearch) {
      return true; // No search filter is applied
    }

    // Allow search by group using unique labels
    var uniqueLabel = (0, _getUniqueLabel2.default)({ groupId: groupId, label: label }).toLowerCase();

    return uniqueLabel.includes(lowercaseSearch);
  });
};